import React, { CSSProperties, FC } from "react";

interface IIconProps {
  style?: CSSProperties;
}

const ProcessingIcon: FC<IIconProps> = ({ style }) => (
  <div style={style} className={`threat threat--big threat--processing`}></div>
);

export default ProcessingIcon;
